import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useState } from 'react'
import { handleError } from '../utils'
import { handleSuccess } from '../utils'
function Signup() {
  const navigate = useNavigate();
  const [signupInfo, setSignupInfo] = useState({
    name: '',
    email: '',
    password: ''
})
const handleChange = (e) => {
   const {id, value} = e.target;
   const copySignupInfo = {...signupInfo};
   copySignupInfo[id] = value
   setSignupInfo(copySignupInfo)
   
}
const handleSignup = async (e) => {
    e.preventDefault();
    const {name, email, password} = signupInfo;
    if(!name || !email || !password){
        return handleError("Please fill all the fields");
    }
    try{
      const baseUrl = process.env.REACT_APP_BACKEND_URL;
      const url = `${baseUrl}/auth/signup`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({name, email, password})
      })
      const result = await response.json();
      console.log("result =>",  result);
      const {success, message} = result;
      if(success){  
        handleSuccess(message);
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
      else {
        // Handle validation errors or other errors
        const errorMessage = result.message || result.error?.message || "Signup failed";
        handleError(errorMessage);
      }
    }catch(error){
      handleError("Signup failed");
    }
}
  return (
    <>
    <div className="auth-container"> 
    <h1>Signup</h1>
    <form onSubmit={handleSignup}>
        <div className="form-group">
            <label htmlFor="name">Name</label>
            <input type="text" className="form-control" id="name" placeholder="Enter name" value={signupInfo.name} onChange={handleChange} />
        </div>
        <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" className="form-control" id="email" placeholder="Enter email" value={signupInfo.email} onChange={handleChange} />
        </div>
        <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" className="form-control" id="password" placeholder="Enter password" value={signupInfo.password} onChange={handleChange} />
        </div>
        <button type="submit" className="btn btn-primary">Signup</button>
        <span>Already have an account? <Link to="/login">Login</Link></span>
    </form>
    </div>
    <ToastContainer 
      position="top-right" 
      autoClose={5000} 
      hideProgressBar={false} 
      newestOnTop={false} 
      closeOnClick 
      rtl={false} 
      pauseOnFocusLoss 
      draggable 
      pauseOnHover 
      style={{ zIndex: 9999 }}
    />
    </>
  )
}

export default Signup